export const GET_LIST_REQUEST_TYPES_REQUEST = 'GET_LIST_REQUEST_TYPES_REQUEST';
export const GET_LIST_REQUEST_TYPES_SUCCESS = 'GET_LIST_REQUEST_TYPES_SUCCESS';
export const GET_LIST_REQUEST_TYPES_FAILURE = 'GET_LIST_REQUEST_TYPES_FAILURE';
